<div class="bg-white pt-6 pt-md-8">
  <div class="container">
    <hr>
    <div class="text-muted extraSmall">
      <p class="mb-0">Desarrollado por <a href="https://faunalab.pe" target="_blank">FAUNA LAB</a> </p>
      <p>¿Problemas? <a href="https://api.whatsapp.com/send?phone=51999905016&text=Hola, te escribo desde el administrador de la web de Canatur" target="_blank">Ayuda técnica</a> </p>
    </div>
    
  </div>  
</div>